import { RG_TYPE, deepFlatChildren } from "@project-rouge/rg-core";
import { addOpeningOnPivot } from "@project-rouge/rg-three";
function addDoorsToEntrances({ building, dataset }) {
	const rvData = dataset.rvData;
	const doorId = dataset.modulousIds.entranceDoorId;
	for (const entrance of building.children.filter((c) => c.type === RG_TYPE.Entrance)) {
		const floors = deepFlatChildren(entrance).filter((c) => c.type === RG_TYPE.Floor);
		const heightPivot = (Math.max(...floors.map((f) => f.pos[1] + f.size[1])) + entrance.anchor[1] * entrance.size[1]) / entrance.size[1];
		addOpeningOnPivot({
			obj: entrance,
			modulousId: doorId,
			rvDataList: rvData,
			type: RG_TYPE.Door,
			pivot: [
				.5,
				heightPivot,
				0
			],
			isEntrance: true
		});
		addOpeningOnPivot({
			obj: entrance,
			modulousId: doorId,
			rvDataList: rvData,
			type: RG_TYPE.Door,
			pivot: [
				.5,
				heightPivot,
				1
			]
		});
	}
}
export { addDoorsToEntrances };

//# sourceMappingURL=index35.js.map